<template>
    <transition name="modal">
        <div class="modal__mask modalpep" v-if="showModalCreate > 0">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_produtos">
                            <img style="width: 40px; height: 47px; margin-top: 10px; margin-bottom: 10px;" src="@/assets/question.png" />
                            <h2>Termos de uso</h2>

                            <div class="conteudo-model" style="max-height: 320px; min-height: 250px; max-width: 400px; padding-right: 25px; padding-left: 25px; overflow-y: auto;">
                                <span v-html="conteudoTermos">
                                </span>
                            </div>
                                                        
                            <div class="
                            " :style="bloquearAceite ? 'justify-content: center; padding-bottom: 30px;' : 'padding-bottom: 30px;'">

                   <div class="row" style="margin-left: 70px">

                    <span style="color: red; margin-left: 0px;" v-if="erroConfirmar">Necessário aceitar os termos para confirmar adesão ao produto</span>


                    <div class="label__field" style="width: 100%; display: inline-flex; margin-bottom: 10px; margin-left: 15px;">

                        <input
                            type="checkbox"
                            class="accept"
                            style="margin-top: 10px;"
                            name=""
                            v-model="aceitoTermos"
                            id="accept"
                            :disabled="bloquearAceite"
                        />

                      <label class="label"   style="margin-top: 6px; margin-left: 5px;" for="accept">Li e aceito os termos de uso.</label>

                    </div>


                            <div class="button-row" style="display: flex; gap: 10px; width: 100%; max-width: 360px;">
                                <button v-if="bloquearAceite != true" class="btnBlue" style="flex: 1;" @click="confirmar">Confirmar</button>
                                <button class="btnDefault" style="flex: 1;" @click="closeModal">Voltar</button>
                            </div>

                           
                            </div>

                            </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';

export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_TERMOS_PRODUTOS",
            bloquearAceite: 'GET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE',
            listaProdutos: 'GET_LISTA_PRODUTOS',
            user: 'auth/user',
        }),
    },
    data() {
        return { 
            nomeEmpresa: '',
            conteudoTermos: '',
            aceitoTermos: false,
            erroConfirmar: false,
        }
    },
    mounted(){
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    },
    watch: {
        showModalCreate(){
            if(this.showModalCreate > 0){
                this.conteudoTermos = this.listaProdutos?.filter(produto => produto.ProdutoId == this.showModalCreate)[0].TermoAdesao;
            }else{
                this.conteudoTermos = '';
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
            this.$store.commit("SET_MODAL_TERMOS_DOCUMENTOS_BLOQUEAR_ACEITE", false);
            this.erroConfirmar = false;
        },

        async confirmar(){
            if(!this.aceitoTermos){
                this.erroConfirmar = true;
            }else{

                try {
                     

                    var obj = { ClienteId: this.user.ClienteId, ProdutoId: this.showModalCreate, Aceite: true, DataAceite: new Date() };

                    const retorno = await api.post('/cliente/produtos', obj);
                    if (retorno.status === 200 && this.nomeEmpresa != 'ACTUAL') {
                            this.$swal({
                                icon: 'success',
                                title: 'Produto incluído',
                                text: 'Produto adicionado com sucesso',
                            }).then((result) => {
                                if (result.value) {
                                    this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS', this.user.ClienteId);
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE', this.user.ClienteId);
                                }
                            });
                    }else if(retorno.status === 200 && this.nomeEmpresa == 'ACTUAL'){
                            this.$swal({
                                icon: 'success',
                                title: 'Produto incluído',
                                text: 'Produto assinado com sucesso',
                            }).then((result) => {
                                if (result.value) {
                                    this.$store.commit("SET_MODAL_TERMOS_PRODUTOS", 0);
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS', this.user.ClienteId);
                                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE', this.user.ClienteId);
                                }
                            });
                    }
                } catch (error) {
                    console.error('Erro na API:', error);
                    this.$swal({
                        icon: 'error',
                        title: 'Oops...',
                        text: `Falha ao adicionar produto ao cliente: ${error.response?.data?.data[0] || error.message}`,
                    });


            }
        }
        }
    },
};
</script>

<style lang="scss" scoped>
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

/* Mobile Styles */
@media (max-width: 768px) {
    .modal__mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 10px !important;
    }
    
    .modal__wrapper {
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        width: 100% !important;
        margin: 0 auto !important;
        height: 100% !important;
    }
    
    .conteudo-model {
        @media (max-width: 768px) {
            max-width: 100% !important;
            padding: 0 15px !important;
        }
    }
    
    .buttonsAcoes {
        width: 100% !important;
        padding: 15px 5px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
    }
    
    .label__field {
        @media (max-width: 768px) {
            margin-left: 0 !important;
            justify-content: center !important;
        }
    }
    
    .row {
        @media (max-width: 768px) {
            margin-left: 0 !important;
            width: 100% !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
        }
    }
}


.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.inner__modal_produtos{
    margin-top: 30px !important;
    width: 350px !important;
    align-content: center;

    @media (max-width: 768px) {
        width: 90% !important;
        margin-top: 10px !important;
    }

    h2{
       margin-bottom: 20px !important;
    }
    span{
    color: #667085;;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    }
    img{
        margin-left: 0;
        display: block;
        margin: 0 auto 10px auto;
    }
}


.modalpep .modal__wrapper .modal__container.reset {
        width: 400px;
        height: 630px !important;
        
        @media (max-width: 768px) {
            width: calc(100% - 40px) !important;
            height: auto !important;
            max-height: 75vh !important;
            margin: 20px !important;
            border-radius: 16px !important;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3) !important;
            padding: 15px !important;
            position: relative !important;
        }
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
